<template>
  <b-badge
    v-if="payout"
    pill
    class="payout-badge d-inline-flex"
    :class="{'not-paid': !payout.is_paid }"
  >
    <a
      href="#"
      @click.prevent="showEditPayoutsModal(payout)"
      :title="'Edit payout ' + payout.payout_number">
      <font-awesome-icon icon="edit"/>
    </a>
    <a
      :id="'payout-file-link-' + payout.id"
      class="ml-1"
      :class="{ 'disabled': !payout.payment_doc_url }"
      target="_blank"
      :href="payout.payment_doc_url"
      :disabled="!payout.payment_doc_url"
    >
      <font-awesome-icon icon="file-invoice"/>
    </a>
    <b-popover
      :target="'payout-file-link-' + payout.id"
      triggers="hover focus"
    >
      <p class="payout-popover-text m-1">{{ payout.payment_doc_file_name }}</p>
      <b-badge
        class="payout-badge d-inline-flex m-1"
        :class="{'not-paid': !payout.is_paid }"
        v-for="(template, key) in templates"
        :key="key"
        pill
      >
        <b-link
          class="template-link payout-popover-text"
          target="_blank"
          :href="payout.payment_doc_url + '/' + template.name"
        >
          {{ template.name }}
        </b-link>
      </b-badge>
    </b-popover>
    <a
      class="ml-1"
      :class="{ 'disabled': payout.payout_type.id === 2 || !payout.worklogs_report_url }"
      target="_blank"
      :href="payout.worklogs_report_url"
      v-b-tooltip.html="{ variant: 'base' }"
      :disabled="!payout.worklogs_report_url"
      :title="'Download worklogs report ' + payout.payout_number">
      <font-awesome-icon icon="file-download" />
    </a>
    <div class="btn-group btn-group__actions" role="group">
      <b-dropdown
        class="dropdown__theme-light navbar__dropdown table__dropdown"
        right
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
      >
        <template v-slot:button-content>
                  <span class="material-icons icon-image-preview">
                    more_vert
                  </span>
        </template>
        <b-dropdown-item-button @click.prevent="showSendPayoutEmailModal(payout)">
                <span class="dropdown-item-link" :class="{ 'active-action-item': !payout.email_sent_date }">
                  <font-awesome-icon icon="envelope" /> Send payout {{ payout.email_sent_date ? '(sent)' : '' }}
                </span>
        </b-dropdown-item-button>
        <b-dropdown-item-button @click.prevent="markAsPaid(payout)">
                  <span class="dropdown-item-link" :class="{ 'active-action-item': !payout.is_paid }">
                    &nbsp;<font-awesome-icon icon="dollar-sign" />&nbsp;&nbsp;Mark Paid {{ payout.is_paid ? '(marked)' : '' }}
                  </span>
        </b-dropdown-item-button>
      </b-dropdown>
    </div>

    <FinancePayoutsEmailModal
      v-model="sendEmailModal.show"
      :title="'test title'"
      :submitButtonText="'test'"
      :payoutId="sendEmailModal.payout ? sendEmailModal.payout.id : null"
      :isLoading="getIsModalLoading"
      @submit="payoutEmailSent"
    />
  </b-badge>
</template>
<script>
import FinancePayoutsEmailModal from './modals/FinancePayoutsModal/FinancePayoutsEmailModal.vue'
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  components: { FinancePayoutsEmailModal },
  props: {
    templates: {
      type: Array
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      payout: null,
      sendEmailModal: {
        payout: null,
        show: false
      }
    }
  },
  computed: {
    ...mapGetters({
      getIsModalLoading: 'finances/getIsModalLoading'
    })
  },
  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler (item) {
        this.payout = item
      }
    }
  },
  methods: {
    showSendPayoutEmailModal (item) {
      this.sendEmailModal.payout = item
      this.sendEmailModal.show = true
    },
    payoutEmailSent (payout) {
      this.payout = cloneDeep(payout)
      this.sendEmailModal.show = false
      this.$emit('updatePayouts')
    },
    showEditPayoutsModal (item) {
      this.$emit('showEditPayoutsModal', item)
    },
    markAsPaid (item) {
      this.$emit('markAsPaid', item)
    }
  }
}
</script>

<style lang="scss" scoped>
  .payout-badge {
    font-size: 14px;
    padding: 5px 12px;
    background-color: #DEEBFF;
    a {
      cursor:pointer;
    }
    a.disabled {
      pointer-events: none;
      opacity: .5;
    }
  }
  .payout-popover-text {
    font-size: 13px;
  }
  .template-link {
    text-decoration: none
  }
  .not-paid{
    background-color: #ede742;
  }
</style>
<style lang="scss">
  .payout-badge .dropdown .dropdown-toggle {
    width: 16px;
    height: 16px;
    .material-icons {
      line-height: 15px;
      font-size: 18px;
    }
  }
</style>
